module.exports = __webpack_public_path__ + "img/ditu.fced6685.png";